import { formatExternalLink } from 'utils/utmLinks';

export const generateSeoUrl: () => string = (url, location) => {
  const urlParams = new URLSearchParams(location.search);

  const linkParams = {
    link: url,
    network: urlParams.get('network'),
    gcLid: urlParams.get('gclid')
  };
  const uri = formatExternalLink(linkParams);
  return uri;
};



// WEBPACK FOOTER //
// ./src/utils/generateSeoUrl/index.js